import Badge from 'components/shared/Badge/Badge';
import Divider from 'components/shared/Divider/Divider';
import Icon from 'components/shared/Icon/Icon';

const TrainingDateCard = ({ formattedDateTime, trainingLink }) => (
  <div className="overflow-hidden rounded-xl border border-solid border-primary-200 bg-primary-50">
    <div className="flex items-center gap-2 px-5 pb-4 pt-5">
      <div className="flex items-center justify-center rounded-lg bg-white p-1.5">
        <Icon icon="calendar-reminder-mono" color="primary" size={20} />
      </div>
      <h3 className="text-base font-500 text-neutral-900">Live training date, time & link</h3>
    </div>

    <div className="flex flex-col gap-4 px-5 pb-5">
      <Divider color="primary-200" />
      <div className="flex flex-col gap-3">
        <span className="text-neutral-600">Date & time:</span>
        {formattedDateTime && formattedDateTime !== 'Unset' ? (
          <Badge color="primary" size="large" variant="light" text={formattedDateTime} />
        ) : (
          <span className="text-sm font-400 text-neutral-900">Not scheduled</span>
        )}
      </div>

      <Divider color="primary-200" />

      <div className="flex flex-col gap-1">
        <span className="text-neutral-600">Link:</span>
        {trainingLink ? (
          <div className="flex items-center gap-2">
            <a
              href={trainingLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-400 !text-neutral-900 !underline">
              {trainingLink}
            </a>
            <Icon
              icon="copy-mono"
              size={16}
              className="cursor-pointer text-neutral-500 hover:text-neutral-700"
              onClick={() => navigator.clipboard.writeText(trainingLink)}
            />
          </div>
        ) : (
          <span className="text-sm font-400 text-neutral-900">
            Link will be available once scheduled
          </span>
        )}
      </div>
    </div>
  </div>
);

export default TrainingDateCard;
